export const ROLES = {
    Player: 'Player',
    Manager: 'Manager'
}
export const TEAMS = {
    Home: 1,
    Away: 2
}